
export default function shorten(text, length = 10, clamp = '...') {
	let content = text.split(' ')
	if (content.length > length) {
		return [...content.slice(0, length), clamp].join(` `)
	}
	return text
}
